var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('returned-checks-table',{ref:"table",attrs:{"kind":"concluded","items":_vm.allReturnedChecks,"with_date_search":"","loading":_vm.loading,"headers":_vm.headers},on:{"dateSearched":_vm.handleDateSearch,"doneUpdate":_vm.handleDoneUpdate,"doneFilter":_vm.handleDoneFilter,"clientSelected":_vm.handleClientSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }